module.exports = __webpack_public_path__ + "static/media/Nguyen_Thuy_Dung.279baae1.jpeg";